module.exports = __webpack_public_path__ + "static/img/artificial-intelligence-leadership.4214227b.webp";